import { HTTPPollingService } from '@timing71/common';

import { Debouncer } from "./debounce.js";
import { getManifest, translate } from "./translate.js";

const DATA_URL = 'https://indycar.blob.core.windows.net/racecontrol/timingscoring-ris.json';
const POLL_RATE = 1000;

const cacheBustedURL = () => `${DATA_URL}?${Date.now()}`;

export class IndyCar extends HTTPPollingService {

  constructor(...args) {
    super(
      cacheBustedURL,
      POLL_RATE,
      ...args
    );

    this._debouncer = new Debouncer();
  }

  async handleResponse(response) {
    if (response) {
      const data = response.replace(/^jsonCallback\(/, '').replace(/\);\r\n$/, '');
      const jsonData = JSON.parse(data);

      this.onManifestChange(getManifest(jsonData));
      this.onStateChange(translate(jsonData, this._debouncer));
    }
  }
}

IndyCar.regex = /(racecontrol\.)?indycar\.com/;
